// checkout/utils/passwordReveal.ts

/**
 * Toggles the visibility of a password input field within a given form row.
 *
 * This function finds the closest ancestor element with the class `.form__row-password`
 * from the provided element, locates the password input within that container,
 * and toggles its type between `"password"` and `"text"` to show or hide the password.
 * Additionally, it toggles the `'active'` class on the provided element to reflect the state.
 *
 * @param {HTMLElement} el - The element that triggered the toggle action (e.g., an eye icon).
 */
export function revealPassword(el: HTMLElement): void {
	const passwordWrapper = el.closest('.password__wrapper') as HTMLInputElement;
	if (!passwordWrapper) return;
	const passwordInput = passwordWrapper.querySelector(
		'input[name="password"], input[type="text"]',
	) as HTMLInputElement;
	if (!passwordInput) return;
	el.classList.toggle('active');
	passwordInput.type = el.classList.contains('active') ? 'text' : 'password';
}
